import ApplicationController from 'javascript/controllers/application_controller';

export default class extends ApplicationController {
  onTurbolinksLoad = () => {
    this.element.classList.remove(this.shouldShowClassName);
  };

  onTurbolinksVisit = () => {
    this.element.classList.add(this.shouldShowClassName);
  };

  connect() {
    this.shouldShowClassName = 'turbolinks-loading-overlay--show';
    this.window.document.addEventListener('turbo:load', this.onTurbolinksLoad);
    this.window.document.addEventListener(
      'turbo:visit',
      this.onTurbolinksVisit,
    );
  }

  disconnect() {
    this.window.document.removeEventListener(
      'turbo:load',
      this.onTurbolinksLoad,
    );
    this.window.document.removeEventListener(
      'turbo:visit',
      this.onTurbolinksVisit,
    );
  }
}
